import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button';
import "../assets/styles/ItemInfoModal.css"
import Figure from "react-bootstrap/Figure"
import { Link } from 'react-router-dom'

export default function ItemInfoModal(props) {
    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            data-bs-theme="dark"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter" className="fw-bold text-light">
                    {props.iteminfomodaldata.name}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex align-items-center justify-content-center flex-column">
                <Figure.Image
                    src={props.iteminfomodaldata.image}
                    style={{border: `0.2rem solid  ${'#' + props.iteminfomodaldata.rarityColor}`}}
                />
                <div className='rarity mt-2 rarity-name rounded pe-2 ps-2 text-light fw-bold' style={{ backgroundColor: `${'#' + props.iteminfomodaldata.rarityColor}` }}>
                    {props.iteminfomodaldata.rarityName}
                </div>
                {
                    props.iteminfomodaldata.heroName !== null ?
                        <div style={{border: `0.2rem solid  ${'#' + props.iteminfomodaldata.rarityColor}`}} className='text-light fs-5 w-100 d-flex align-items-center w-100 mt-3 slot'>
                            <div className='tag ms-2 fw-bold fs-4 me-2'>Hero</div><span className="hero-name">: {props.iteminfomodaldata.heroName}</span>
                        </div>
                        :
                        ""
                }
                {
                    props.iteminfomodaldata.slot !== null ?
                        <div style={{border: `0.2rem solid  ${'#' + props.iteminfomodaldata.rarityColor}`}} className='text-light fs-5 w-100 d-flex align-items-center w-100 mt-2 slot'>
                            <div className='tag ms-2 fw-bold fs-4 me-2'>Slot</div><span className="item-slot">: {props.iteminfomodaldata.slot}</span>
                        </div>
                        :
                        ""
                }
                <div style={{border: `0.2rem solid  ${'#' + props.iteminfomodaldata.rarityColor}`}} className='text-light fs-5 w-100 d-flex align-items-center w-100 mt-2 slot'>
                    <div className='tag ms-2 fw-bold fs-4 ms-0 me-2'>Price</div><span className="item-price">: {props.iteminfomodaldata.priceSafe} $</span>
                </div>
                <div className=' w-100 d-flex align-items-center justify-content-center mt-5 item-links'>
                    <Link className="me-3" target="_blank" rel="noopener noreferrer" to={props.iteminfomodaldata.steamUrl}>
                        <i className="text-light bi bi-steam"></i>
                    </Link>
                    <Link target="_blank" rel="noopener noreferrer" to={`https://steamcommunity.com/profiles/${props.steamid}/inventory/#570_2_${props.iteminfomodaldata.assetId}`}>
                        <i className="text-light bi bi-box-seam-fill"></i>
                    </Link>
                </div>
            </Modal.Body>
        </Modal>
    );
}